import React from 'react';
import './footer.css';
import { FaFacebookF, FaBehance, FaInstagram, FaDribbble } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer>
      {/* === Contact Form Section === */}
      {/* <div className="contact-section">
        

        <div className="contact-form-box">
          <h2 className='services-heading'>Have questions?<br />Get in touch!</h2>
          <form>
            <input type="text" placeholder="Name" required />
            <input type="email" placeholder="Email" required />
            <input type="text" placeholder="Subject" />
            <textarea placeholder="Message" rows="4"></textarea>
            <div className="checkbox">
              <input type="checkbox" id="consent" />
              <label htmlFor="consent">
                I agree that my submitted data is being <a href="#">collected</a> and <a href="#">stored</a>.
              </label>
            </div>
            <button type="submit">Send Message</button>
          </form>
        </div>
      </div> */}

      {/* === Footer Content === */}
      <div className="footer">
        <div className="footer-container">

          <div className="footer-col">
            <div className="footer-logo">
              {/* <span className="logo-icon">🛠️</span> */}
              <span className="logo-text">HANDYMAN</span>
            </div>
            <p>
              At Tasker, we bring craftsmanship and care together to build strong spaces.
              Our skilled team is ready to repair, renovate, and elevate your home.
            </p>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <p>info@email.com</p>
            <p>Germany –<br />785 15h Street, Office 47<br />Berlin, De 81566</p>
          </div>

          <div className="footer-col">
            <h4>Links</h4>
            <ul>
              <li><a href="/templates/handyman/">Home</a></li>
              <li><a href="/templates/handyman/about-us">About Us</a></li>
              <li><a href="/templates/handyman/services">Services</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Get in Touch</h4>
            <div className="social-icons">
              <a href="/templates/handyman/"><FaFacebookF /></a>
              <a href="/templates/handyman/"><FaBehance /></a>
              <a href="/templates/handyman/"><FaInstagram /></a>
              <a href="/templates/handyman/"><FaDribbble /></a>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
